// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1Rcua";
export var head = "hero-module--head--1lnjI";
export var title = "hero-module--title--SKSFT";
export var subtitle = "hero-module--subtitle--3ztNZ";
export var mediaWrap = "hero-module--mediaWrap--2kRTv";
export var mediaWrap_mobileImage = "hero-module--mediaWrap_mobileImage--2R7lB";
export var partnersWrap = "hero-module--partnersWrap--1StRA";
export var partnersWrap_title = "hero-module--partnersWrap_title--37MeR";